import { Identifier } from "../../core";
export class ModifierTypeId extends Identifier {
    constructor(id) {
        super("ModifierTypeId", id);
    }
}
